import { accountLockedErrorMessageKey, invalidCodeErrorMessageKey } from './constants';
import { t } from '../../../../infra/i18n';
export var isVerificationAvailable = function (user, verificationType) {
    if (!user || !user.multiFactorConfigs) {
        return false;
    }
    return user.optIn2FA && user.multiFactorConfigs.some(function (config) { return config.type === verificationType; });
};
export var getMaskedContact = function (user, verificationType) {
    var _a;
    if (!user || !user.multiFactorConfigs) {
        return '';
    }
    return ((_a = user.multiFactorConfigs.find(function (config) { return config.type === verificationType; })) === null || _a === void 0 ? void 0 : _a.destination) || '';
};
export var getErrorMessage = function (status, isLockedOut) {
    if (status === 'fail') {
        return isLockedOut ? t(accountLockedErrorMessageKey) : t(invalidCodeErrorMessageKey);
    }
    return null;
};
